import View from '../View';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS} from '@packages/systems/core/constants/SharedConstraintRules';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Payment Info',
  showEmpty: true,
  constraints: {
    ancestors: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommerceCheckoutFormContainer', rule: 'ExactlyOne'},
    ],
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommerceCheckoutCardExpirationDate', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutCardNumber', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutCardSecurityCode', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutBillingAddressToggleWrapper', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
